<template>
  <div class="grid">
    <div class="park-link" v-for="city in cities" :key="city.id">
      <Park :city="city"/>
    </div>
  </div>
</template>

<script>
import Park from "../components/Park"

export default {
  name: 'AllParks',
  props: ["cities"],
  components: {
    Park
  }
}
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  padding-top: 81px;
  background: linear-gradient(to right, #3b8d99, #6b6b83, #aa4b6b);  
  width: 100%;
  min-height: 100vh;
  grid-auto-rows: 250px;
  @media (min-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
    padding-top: 15vh;
  }

}

.park-link {
  cursor: pointer;
}

</style>
